import React from 'react';
import { Button, ButtonIcon, NavLink } from '@storebrand-digital/pretzel';
import { getText } from '@storebrand-digital/fms-translations';
import {
  Link as ReactRouterLink,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import styles from './Navigation.module.css';
import { useKron } from '../../app/hooks/useKron';
import { getCurrentTheme, isKronWebApp, KRON_DARK } from '../../utils';
import { useScrollToTop } from '../../utils/scrollToTop';
import { usePreviewContext } from '../../containers/Preview/context';
import useDerivedSearchParams from '../../containers/Filter/hooks/useDerivedSearchParams';
import KronLogoDark from '../../assets/kron-logo-dark.svg';
import KronLogoLight from '../../assets/kron-logo-light.svg';
import { isKronWebView } from '@storebrand-digital/kron-web-view-helpers';

export const Navigation = () => {
  const { closeWebView } = useKron();
  const navigate = useNavigate();
  const location = useLocation();
  useScrollToTop();
  const { derivedSearchParams, origin } = useDerivedSearchParams();
  const isHome = location.pathname === '/';
  const isPreview = location.pathname.includes('/pdf');
  const { downloadUrl, downloadFilename, downloadTrackId, isErrorFetchingPDF } =
    usePreviewContext();
  const showDownloadButton = isPreview && !isErrorFetchingPDF && downloadUrl;
  if (isKronWebView) {
    return (
      <nav className={styles.navAppView}>
        <div className={styles.navbar} data-kron-web-view="true">
          <ButtonIcon
            aria-label="back"
            label="back"
            onClick={() => (isHome ? closeWebView(false) : navigate(-1))}
            icon="arrow-left"
            size="xlarge"
          />
        </div>
      </nav>
    );
  }

  return (
    <div className={styles.navWebview}>
      {isKronWebApp && (
        <div className={styles.navbar} data-webview="true">
          <div className={styles.logoWrapper}>
            <img
              alt="Kron"
              src={
                getCurrentTheme() === KRON_DARK ? KronLogoDark : KronLogoLight
              }
            />
          </div>
        </div>
      )}

      {isPreview && (
        <div className={styles.navbar}>
          {origin ? (
            <Button
              className={styles.backButton}
              variant="subtle"
              iconLeft="arrow-left"
              onClick={() => navigate(-1)}
              size="medium"
            >
              {getText('goBackLink.label')}
            </Button>
          ) : (
            <NavLink
              iconPosition="left"
              data-trackid="button-back|Til arkivet"
              as={ReactRouterLink}
              to={{
                pathname: '/',
                search: derivedSearchParams,
              }}
            >
              {getText('toArchiveLink.label')}
            </NavLink>
          )}

          {showDownloadButton && (
            <Button
              as="a"
              href={downloadUrl}
              download={downloadFilename}
              variant="subtle"
              iconRight="download"
              data-trackid={downloadTrackId}
              disabled={!downloadUrl}
              size="medium"
            >
              {getText('document.download.label')}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
